import { FieldValue, Timestamp } from "firebase/firestore";
import { NewGoodsControl, PutGoodsControl } from "../../domain/control/Goods";
import { undefinedToNull } from "../../util/object";
import { formatDateAsTime } from "../../util/date";
import { isNil } from "lodash";

export type GetGoodsControlDto = {
  provider?: string;
  departure?: string;
  description?: string;
  document?: string;
  documentType?: string;
  entry?: string;
  guide?: string;
  observation?: string;
  ownerUid: string;
  unityId?: number;
  photo?: string;
  timestamp: Timestamp;
};

export type PostGoodsControlDto = {
  ownerUid: string;
  unityId: number;
  entry: string;
  departure?: string;
  timestamp: FieldValue;
  description: string;
  provider: string;
  guide: string;
  photo?: string;
  observation?: string;
  document?: string;
  documentType?: string;
};

export type PutGoodsControlDto = {
  departure?: string | null;
  observation?: string | null;
};

export const newGoodsControlAsDto: (
  c: NewGoodsControl
) => Partial<PostGoodsControlDto> = (newControl) =>
  undefinedToNull({
    ...newControl,
    timestamp: Timestamp.now(),
    entry: formatDateAsTime(newControl.entry),
    departure: !isNil(newControl.departure)
      ? formatDateAsTime(newControl.departure)
      : null,
  });

export const putGoodsControlAsDto: (
  c: PutGoodsControl
) => Partial<PutGoodsControlDto> = (putControl) =>
  undefinedToNull({
    ...putControl,
    departure: !isNil(putControl.departure)
      ? formatDateAsTime(putControl.departure)
      : null,
  });
